import { Directive, HostListener, Input } from '@angular/core';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';

@Directive({
  selector: '[ga]'
})
export class GaDirective {
  // tslint:disable-next-line: no-input-rename
  @Input('ga') data: any;

  constructor(private ga: GoogleAnalyticsService) { }

  @HostListener('click')
  onclick() {
    if (this.data) {
      if (Array.isArray(this.data)) {
        this.ga.sendEvent(this.data?.[0], { action: this.data?.[1], label: this.data?.[2] });
      } else {
        this.ga.sendEvent(this.data?.category, this.data);
      }
    }
  }
}
